var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabs"},_vm._l((_vm.routes),function(route){return _c('router-link',{key:route.name,staticClass:"tabs__link",attrs:{"to":route}},[_vm._v(" "+_vm._s(route.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }